
import styles from './noWeather.module.css';
import { Link } from 'react-router-dom';
import { useTripInfo } from '../context';

export function NoWeather(props) {
  const { currentTripId } = useTripInfo();
    return (
        
          
        <>
            <div style={{ display: 'flex', justifyContent: 'center', height: '75vh' }}>
                <div className={styles.noWeather}>
                    {props.type === 'noLocationToExplore' ? 
                       <img src="no_location.png" alt="" style={{ width: '35vw', height: 'auto', maxWidth: '300px' }} />
                       :
                          <img src="noWeather.png" alt="" style={{ width: '35vw', height: 'auto', maxWidth: '300px' }} />
                    
                 
                    }
                    <br />
               
                    {props.type === 'notActive' &&
                    <h3>Forecast will be available 5 days before your trip starts.! 🌤</h3>}
                       
                    {props.type === 'end' &&
                        
                         <h3>OH!! Forecast is only available while your trip is active!</h3>}

                    {props.type === 'noLocation' && <>
                        <p style={{ fontWeight: '600' }}>Your current destination isn&apos;t valid for retrieving weather data!</p>
                        <br />

                        <p>
                            Please <Link className="text-gray-600 underline hover:text-blue-600" to={`/update_trip/${currentTripId}`}>update</Link> your destination with a more specific city or region to view the forecast.
                        </p>
                    </>

                    }
                     {props.type === 'noLocationToExplore' && <>
                        <p style={{ fontWeight: '600' }}> Your current destination needs more detail!</p>
                        <br />

                        <p>
                            Please <Link className="text-gray-600 underline hover:text-blue-600" to={`/update_trip/${currentTripId}`}>update</Link> your destination to explore attractions, hotels, flights, and more.
                        </p>
                    </>

                    }
                    


                </div>
            </div>
        </>
    )
}